import { render } from "./CModal.vue?vue&type=template&id=df012e8e"
import script from "./CModal.vue?vue&type=script&lang=js"
export * from "./CModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__